var ParcoursMapView = Backbone.View.extend({

    initialize:function(){
        var self = this;

        this.$ParcoursMap = $("#ParcoursMap");
        this.$ParcoursMapTooltip = $("#ParcoursMapTooltip");

        this.$ParcoursMapTooltipArtworks = $("#ParcoursMapTooltip .tooltip_artworks");
        this.tooltipArtworksPosition = 0;

        this.$ParcoursMapTooltipObjectName = $("#ParcoursMapTooltip .tooltip_objectname");
        this.$ParcoursMapTooltipLocations = $("#ParcoursMapTooltip .tooltip_object_locations");
        this.$ParcoursMapTooltipIndic = $("#ParcoursMapTooltip .nav_indic");

        this.$MapRazBt = $("#MapRazBt");

        this.tooltipWidth = 400;

        this.initialLoading = true;
        this.zoom = 3.5;
        this.hasClickedArc = false;
        this.isDefaultMoving = true;

        this.parcoursData = [{"city_to": "New York", "latitude_target": 40.7127753, "longitude_target": -74.0059728, "city_from": "Hamburg", "latitude_source": 53.5510846, "longitude_source": 9.9936819, "category": "business"}, {"city_to": "Munich", "latitude_target": 48.1351253, "longitude_target": 11.5819805, "city_from": "Hamburg", "latitude_source": 53.5510846, "longitude_source": 9.9936819, "category": "private"}, {"city_to": "Treviso", "latitude_target": 45.6668893, "longitude_target": 12.2430437, "city_from": "Hamburg", "latitude_source": 53.5510846, "longitude_source": 9.9936819, "category": "private"}, {"city_to": "Basel", "latitude_target": 47.5595986, "longitude_target": 7.5885761, "city_from": "Hamburg", "latitude_source": 53.5510846, "longitude_source": 9.9936819, "category": "private"}, {"city_to": "Mallorca", "latitude_target": 39.6952629, "longitude_target": 3.0175712, "city_from": "Hamburg", "latitude_source": 53.5510846, "longitude_source": 9.9936819, "category": "private"}, {"city_to": "Bilbao", "latitude_target": 43.2630126, "longitude_target": -2.9349852, "city_from": "Hamburg", "latitude_source": 53.5510846, "longitude_source": 9.9936819, "category": "business"}, {"city_to": "Berlin", "latitude_target": 52.5200066, "longitude_target": 13.404954, "city_from": "Hamburg", "latitude_source": 53.5510846, "longitude_source": 9.9936819, "category": "business"}, {"city_to": "Hamburg", "latitude_target": 53.5510846, "longitude_target": 9.9936819, "city_from": "Lviv", "latitude_source": 49.839683, "longitude_source": 24.029717, "category": "private"}, {"city_to": "Hurgada", "latitude_target": 27.2578957, "longitude_target": 33.8116067, "city_from": "Cairo", "latitude_source": 30.0444196, "longitude_source": 31.2357116, "category": "private"}, {"city_to": "Lviv", "latitude_target": 49.839683, "longitude_target": 24.029717, "city_from": "Hurgada", "latitude_source": 27.2578957, "longitude_source": 33.8116067, "category": "private"}, {"city_to": "Cairo", "latitude_target": 30.0444196, "longitude_target": 31.2357116, "city_from": "Luxor, Egypt", "latitude_source": 25.6872431, "longitude_source": 32.6396357, "category": "private"}];
    },

    render:function(){
        var self = this;

        this.map = new mapboxgl.Map({
            container: 'ParcoursMap',
            center: [-20.276018, 50.220830],
            zoom: 1.6,
            pitch: 25,
            //maxPitch: 50,
            bearing: 0,
            minZoom: 1,
            maxZoom: 15,
            renderWorldCopies: false,
            style: "mapbox://styles/clementthorez/ckqi39rmhen4n18nqjj71rtfn",
        });

        /*
        this.map.on('render', (e) => {
          if (e.target.getPitch() > MAX_PITCH) e.target.setPitch(MAX_PITCH)
        })
        */

        //

        
        this.map.on('load', async () => {
     
            self.map.on('move', function (e) {
                if(self.isDefaultMoving) {
                } else {
                    App.$App.attr("data-mapdefault", "false");
                }
            })
        });

        //this.map.setRenderWorldCopies(false);
        this.map.addControl(new mapboxgl.NavigationControl({showCompass: false, visualizePitch: false}), "bottom-left");

        this.bindEvents();
    },

    reload: function () {
        var self = this;

        this.hideMapTooltip();
        this.isDefaultMoving = true;
        this.map.remove();
        this.map = new mapboxgl.Map({
            container: 'ParcoursMap',
            center: this.centroid,
            zoom: 1.6,
            pitch: 25,
            //maxPitch: 50,
            bearing: 0,
            minZoom: 1,
            maxZoom: 15,
            renderWorldCopies: false,
            style: "mapbox://styles/clementthorez/ckqi39rmhen4n18nqjj71rtfn",
        });

        this.map.addControl(new mapboxgl.NavigationControl({showCompass: false}), "bottom-left");

        this.map.on('load', async () => {
            await untilMapEvent('idle');
            App.update();
            App.isReloadingMap = false;

            self.map.on('move', function (e) {
                if(self.isDefaultMoving) {
                } else {
                    App.$App.attr("data-mapdefault", "false");
                }
            })

            self.map.__deck.props.getCursor = () => self.map.getCanvas().style.cursor;
        })
    },

    update: function () {
        var self = this;
        this.mappedParcours = [];

        var similarParcours = _.group

        _.each(App.groupedRealParcours, function (obj, groupId){
            var objParcours = obj.parcours[0];
            objParcours.groupId = groupId;

            var parcoursWidth = (obj.parcours.length * (15/98)) + (115/49);
            if(parcoursWidth > 5) parcoursWidth = 5;
            objParcours.width = parcoursWidth;
            objParcours.height = obj.height;

            if(objParcours.real_longitude_source > 90 || objParcours.real_longitude_source < -90) console.log("error source", obj);
            if(objParcours.real_longitude_target > 90 || objParcours.real_latitude_target < -90) console.log("error target", obj);

            self.mappedParcours.push(objParcours);
        });

        this.arcsLayer = new deck.MapboxLayer({
            type: ArcBrushingLayer,
            id: "arcs",
            data: self.mappedParcours,
            opacity: 0.1,
            coef: 0.001,
            //onHover: (info, event) => (info.object !== undefined) ? self.displayMapTooltip(info.object) : "",
            onClick: (info, event) => (info.object !== undefined) ? self.displayMapTooltip(info.object) : "",
            pickable: true,
            onHover:function(e){ if(e.index == -1) self.map.getCanvas().style.cursor = 'grab'; else self.map.getCanvas().style.cursor = 'pointer';},
            getWidth: d => d.width,
            getHeight: d => d.height,
            autoHighlight: true,
            getSourcePosition: d => [d.real_longitude_source, d.real_latitude_source],
            getTargetPosition: d => [d.real_longitude_target, d.real_latitude_target],
            getSourceColor: d => d.color_source,
            getTargetColor: d => d.color_target, // 23,86,118
        });

        var allLat = _.map(this.mappedParcours, function (o) { 
            return [o.latitude_source, o.latitude_target];
        });
        allLat = _.flatten(allLat);
        this.maxLat = _.max(allLat);
        this.minLat = _.min(allLat);

        var allLong = _.map(this.mappedParcours, function (o) { 
            return [o.longitude_source, o.longitude_target];
        });
        allLong = _.flatten(allLong);
        this.maxLong = _.max(allLong);
        this.minLong = _.min(allLong);

        this.maxDistance = App.utils.getDistanceFromLatLonInKm(this.minLat, this.minLong, this.maxLat, this.maxLong);

        var latShifting = 30;
        if(this.maxDistance < 1) {
            this.zoom = 12;
            latShifting = 0.01;
        } else if(this.maxDistance < 10) {
            this.zoom = 9;
            latShifting = 0.5;
        }  else if(this.maxDistance < 50) {
            this.zoom = 8;
            latShifting = 2.5;
        } else if(this.maxDistance < 100) {
            this.zoom = 7;
            latShifting = 5;
        } else if(this.maxDistance < 500) {
            this.zoom = 5;
            latShifting = 5;
        } else if(this.maxDistance < 1000) {
            this.zoom = 4.5;
            latShifting = 10;
        } else if(this.maxDistance < 3000) {
            this.zoom = 3.5;
            latShifting = 10;
        } else {
            this.zoom = 2;
        }

        this.centroid = [((this.maxLong + this.minLong) / 2), ((this.maxLat + this.minLat) / 2)]

        this.map.on('load', async () => {
            self.map.addLayer(self.arcsLayer) // add arc layer

            self.initialLoading = false;
             // wait until the map settles
            await untilMapEvent('idle');
            await animate(); // run all the animations

            self.map.on('move', function (e) {
                if(self.isDefaultMoving) {
                } else {
                    App.$App.attr("data-mapdefault", "false");
                }
            })

            self.map.__deck.props.getCursor = () => self.map.getCanvas().style.cursor;
        });

        if(!this.initialLoading){
            if(App.parcoursMapView.map.getLayer("arcs") !== undefined) App.parcoursMapView.map.removeLayer("arcs");
            self.map.addLayer(self.arcsLayer) // add arc layer
            if(self.mappedParcours.length > 0) animate();
            self.map.__deck.props.getCursor = () => self.map.getCanvas().style.cursor;
        }

        this.hideMapTooltip();
    },

    bindEvents:function(){
        var self = this

        this.$ParcoursMap.on("click", function (){
            if(self.hasClickedArc) self.hasClickedArc = false;
            else self.hideMapTooltip();
        })

        this.$ParcoursMapTooltip.find(".nav_arrow.prev").on("click", function (){
            if(!$(this).hasClass("disabled")) {
                self.tooltipArtworksPosition += self.tooltipWidth;
                self.moveTooltipCarousel();
            }
            
        })

        this.$ParcoursMapTooltip.find(".nav_arrow.next").on("click", function (){
            if(!$(this).hasClass("disabled")) {
                self.tooltipArtworksPosition -= self.tooltipWidth;
                self.moveTooltipCarousel();
            }
        })

        this.$MapRazBt.on("click", function () {
            self.isDefaultMoving = true;
            App.$App.attr("data-mapdefault", "true");
            self.map.flyTo({
                center: App.parcoursMapView.centroid,
                zoom: App.parcoursMapView.zoom,
                pitch: 25,
                bearing: 0,
                duration: 500,
                speed: 0.5,
                essential: true
            });

            setTimeout(function (){
                self.isDefaultMoving = false;
            }, 1000)
        });

        $(".tooltip_closebt").on("click", function (){
            self.hideMapTooltip();
        })
    },

    moveTooltipCarousel: function () {
        $(".nav_arrow").removeClass("disabled");
        var nbArtwork = Math.abs(Math.round(this.tooltipArtworksPosition / this.tooltipWidth)) + 1;
        var totalArtworks = this.$ParcoursMapTooltip.attr("data-nbartworks");

        if(nbArtwork == 1) {
            this.$ParcoursMapTooltip.find(".nav_arrow.prev").addClass("disabled");
        } else if(nbArtwork == totalArtworks) {
            this.$ParcoursMapTooltip.find(".nav_arrow.next").addClass("disabled");
        }

        
        this.$ParcoursMapTooltipIndic.html(nbArtwork + "/" + totalArtworks);
        this.$ParcoursMapTooltipArtworks.css("left", this.tooltipArtworksPosition + "px");
    },
    

    hideMapTooltip: function () {
        this.hasClickedArc = false;
        this.$ParcoursMapTooltip.removeClass("displayed");
    },

    displayMapTooltip: function (mappedParcoursObject) {
        var self = this;
        var allParcours = App.groupedRealParcours[mappedParcoursObject.groupId].parcours;
        
        this.$ParcoursMapTooltip.attr("data-nbartworks", allParcours.length);
        this.$ParcoursMapTooltipArtworks.css("width", (this.tooltipWidth * allParcours.length) + "px")
                                .empty();

        this.tooltipArtworksPosition = 0;
        $(".nav_arrow").removeClass("disabled");
        $(".nav_arrow.prev").addClass("disabled");
        this.$ParcoursMapTooltipArtworks.css("left", "0px");
        this.$ParcoursMapTooltipIndic.html("1/" + allParcours.length);

        _.each(allParcours, function (artworkParcours){
            var $artwork = $("<div class='artwork'></div>");

            var objectParams = _.find(App.objetsWithLocation, function (o){
                return o.id_objet == artworkParcours.id_objet
            })

            if(objectParams.sortedVentes.length > 0) $artwork.append("<a class='artwork_link' href='"+objectParams.URL_objet_AGORHA+"' target='_blank'>Voir sur agorha</a>");
            $artwork.append("<div class='artwork_name'>"+objectParams.nom_objet+"</div>");

            var strDate = "date inconnue";
            if(objectParams.lieu_creation_nom != "" && objectParams.lieu_creation_nom != undefined) {
                var strCreationLocation = objectParams.lieu_creation_nom;

                if(strCreationLocation == "Information manquante") {
                    strCreationLocation = "<span class='missing'>Lieu manquant</span>";
                } else {
                    if(objectParams.lieu_creation_pays !== "") strCreationLocation += " ("+objectParams.lieu_creation_pays+")";
                    if(objectParams.date_creation_string !== "") strDate = objectParams.date_creation_string;
                }


                if(strDate == "Information manquante" || strDate == "date inconnue") strDate = "<span class='missing'>Date manquante</span>";

                var $creationItem = $("<div class='location_item' data-type='creation'><div class='item_label'>Création</div><div class='item_value'>"+strCreationLocation+", <i>"+strDate+"</i></div></div>");
                $artwork.append($creationItem);
            }

            if(objectParams.lieu_decouverte_nom != "" && objectParams.lieu_decouverte_nom != undefined) {
                var strDecouverteLocation = objectParams.lieu_decouverte_nom;
                strDate = "date inconnue";

                if(strDecouverteLocation == "Information manquante") {
                    strDecouverteLocation = "<span class='missing'>Lieu manquant</span>";
                } else {
                    if(objectParams.lieu_decouverte_pays !== "") strDecouverteLocation += " ("+objectParams.lieu_decouverte_pays+")";
                    if(objectParams.date_decouverte_string !== "") strDate = objectParams.date_decouverte_string;
                }

                if(strDate == "Information manquante" || strDate == "date inconnue") strDate = "<span class='missing'>Date manquante</span>";
                var $decouverteItem = $("<div class='location_item' data-type='decouverte'><div class='item_label'>Découverte</div><div class='item_value'>"+strDecouverteLocation+", <i>"+strDate+"</i></div></div>");
                $artwork.append($decouverteItem);
            }

            _.each(objectParams.sortedVentes, function (objVente){
                strDate = "date inconnue";
                var $venteItem = $("<div class='location_item' data-type='vente'><div class='item_label'>Vente</div><div class='item_value'>"+objVente.vente_nom+" ("+objVente.vente_ville+", "+objVente.vente_pays+"), <i>"+objVente.vente_date+"</i></div></div>");
                $artwork.append($venteItem);
            })

            if(objectParams.conservation_nom != "" && objectParams.conservation_nom != undefined) {
                var strConservationLocation = objectParams.conservation_nom;
                strDate = "date inconnue";

                if(strConservationLocation == "Localisation inconnue" || strConservationLocation == "Information manquante") {
                    strConservationLocation = "<span class='missing'>Musée manquant</span>";
                } else {
                    if(objectParams.conservation_pays !== "") strConservationLocation += " ("+objectParams.conservation_pays+")";
                    if(objectParams.conservation_date_entree != "") strDate = objectParams.conservation_date_entree;
                }

                if(strDate == "Information manquante" || strDate == "date inconnue") strDate = "<span class='missing'>Date manquante</span>";

                var $conservationItem = $("<div class='location_item' data-type='conservation'><div class='item_label'>Conservation</div><div class='item_value'>"+strConservationLocation+", <i>"+strDate+"</i></div></div>");
                $artwork.append($conservationItem);
            }

            self.$ParcoursMapTooltipArtworks.append($artwork);
        })

        setTimeout(function (){
            self.$ParcoursMapTooltip.addClass("displayed")
        }, 1)

        this.hasClickedArc = true;
    },

    clickParcours: function (mappedParcoursObject) {
        console.log("clickParcours", mappedParcoursObject);
    }
});

module.exports = ParcoursMapView;